import { Skeleton } from '../../../components/ui/skeleton';

function DeviceCardSkeleton() {
    return (
        <div
            aria-hidden='true'
            data-testid='device-card-skeleton'
            className='flex h-full w-full flex-col items-center gap-3 rounded-[28px] bg-white p-4'
        >
            <Skeleton className='h-5 w-24' />

            <div className='flex aspect-square w-full max-w-[150px] flex-col items-center justify-center rounded-full border border-slate-200 bg-white'>
                <div className='flex w-full items-center justify-center gap-2 px-5'>
                    <span className='h-px flex-1 bg-slate-200'></span>
                    <Skeleton className='h-3 w-8' />
                    <span className='h-px flex-1 bg-slate-200'></span>
                </div>
                <div className='my-3 flex items-center justify-center'>
                    <Skeleton className='h-9 w-20' />
                </div>
                <div className='flex w-full items-center justify-center gap-2 px-5'>
                    <span className='h-px flex-1 bg-slate-200'></span>
                    <Skeleton className='h-3 w-8' />
                    <span className='h-px flex-1 bg-slate-200'></span>
                </div>
            </div>

            <div className='mt-3 flex w-full justify-center'>
                <Skeleton className='h-3 w-28' />
            </div>
        </div>
    );
}

export default DeviceCardSkeleton;
